import { useContext } from 'react';
import { AuthContext } from '../config/KeycloakProvider';

export const useKeycloak = () => {
  return useContext(AuthContext);
};
